import { Record, List } from 'immutable';
import { actionTypes, fetchParticipantInfoActions } from './auth.actions';
import * as login from '../login/login.actions';
import { changeEmailActions } from '../acct';
import * as api from '../api';

export const AuthReducerState = Record({
  participantInfo: api.ApiCallState({}),
  err: null,
  isAuthenticated: false,
  isRevoked: false,
  useLoginModal: false,
  isFetching: false,
  authToken: null,
  currentSession: null,
  /** set after user successfully logs out of the portal */
  justLoggedOut: false
});

export const CurrentSessionState = Record({
  user: new Record({}),
  session: new Record({}),
  programs: new List([])
});

export const authReducer = (initialState = new AuthReducerState({
  authToken: localStorage.getItem('authToken') || null
}), action) => {

  var state = initialState;
  state = state.set('participantInfo', api.apiCallReducer(state.get('participantInfo'), action, fetchParticipantInfoActions));

  switch (action.type) {
    case changeEmailActions.updateEmailActions.success:
      return state.setIn(['currentSession', 'user'], { ...state.currentSession.user, email: action.data.email});
    case login.actionTypes.CREATE_NEW_SESSION_BEGIN:
      return state.set('isRevoked', false)
    case login.actionTypes.CREATE_NEW_SESSION_SUCCESS:
      return state.set('authToken', action.data.token);
    case actionTypes.DELETE_CURRENT_SESSION_SUCCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', false)
                  .set('currentSession', null);
    case actionTypes.DELETE_CURRENT_SESSION_FAILURE:
      return state.set('isFetching', false)
                  .set('err', action.err);
    case actionTypes.INVALIDATE_CURRENT_SESSION:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', false);
    case actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', true);
    case actionTypes.REVOKE_ACCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('authToken', null)
                  .set('useLoginModal', false)
                  .set('isRevoked', true)
                  .set('currentSession', null);
    case actionTypes.FETCH_CURRENT_SESSION_BEGIN:
      return state.set('isRevoked', false)
                  .set('isFetching', true)
                  .set('currentSession', null)
                  .set('err', null);
    case actionTypes.FETCH_CURRENT_SESSION_SUCCESS:
      return state.set('isFetching', false)
                  .set('isAuthenticated', true)
                  .set('currentSession', new CurrentSessionState(action.data))
                  .set('useLoginModal', false);
    case actionTypes.FETCH_CURRENT_SESSION_FAILURE:
      return state.set('isFetching', false)
                  .set('isAuthenticated', false)
                  .set('currentSession', null)
                  .set('err', action.err);
    case actionTypes.LOGOUT:
      return state.set('isFetching', true)
                  .set('justLoggedOut', true);
    case actionTypes.LOGOUT_RESET:
      return state.set('justLoggedOut', false);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/auth/auth.reducer.js